import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from 'react';
import { useIntl, useSelector } from 'umi';
import { getCountryFlag } from '@/pages/home/_config/countries';
import ParentSubsidiaryCompanySelect from '../ParentSubsidiaryCompanySelect';
import FollowBtn from '../FollowBtn';
import RenameAddGroup from '@/pages/intelligence/pages/Following/Manage/RenameAddGroup';
import AddGroup from '@/pages/intelligence/pages/Following/Manage/AddGroup';
import type { IBaseProps } from '@/pages/intelligence/types/common';
import { FormMode } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import './index.scss';
import { fetchFollowingGroups } from '@/pages/intelligence/services/following';
import {
  getFollowing,
  setFollowing,
} from '@/pages/intelligence/services/topcharts';
import CompanyUserGuide, {
  COMPANY_GUIDE_CLASSNAMES,
} from '@intelligence/components/UserGuide/Company';
import GameImage from '@/pages/home/components/GameImage';

const DEFAULT_GROUPNAME = 'All Companies'; //默认是All Companies
interface ICompaniesHeaderProps extends IBaseProps {
  companyId: string;
  onCompanyIdChange: (payload: string) => void;
  basicInfo: any;
  getIsOnSubsidiary: (payload: boolean) => void;
}

const CompanyHeader = (porps: ICompaniesHeaderProps) => {
  const { companyId, onCompanyIdChange, basicInfo, getIsOnSubsidiary } = porps;
  const genres: string[] = basicInfo?.genre?.split(',') ?? [];

  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });
  const userId = userInfo?.userid ?? '';
  // console.log('userIduserId', userId);

  const { formatMessage } = useIntl();
  const entityType = 'company';
  const [createNewGroup, setCreateNewGroup] = useState(false);
  const [addGroup, setAddGroup] = useState(false);
  const [favarite, setFavarite] = useState<any>(false);
  const [groupOptions, setGroupOptions] = useState<any[]>([]);
  const [addNewGroupName, setAddNewGroupName] = useState('');
  // 新增、重命名分组 区分标识
  const MODE = FormMode.Add;
  // 缓存最近一次更新后的收藏状态，用于收藏失败时，回退到最近的正确的收藏状态
  const cachedValue = useRef<boolean>(false);

  const initialIsFollowing = async (entityId: string) => {
    const res = await getFollowing({
      user_id: userId,
      game_company_id: entityId,
    });
    const valueTmp = res?.data === 'true' || res?.data === '已收藏';
    cachedValue.current = valueTmp;
    setFavarite(valueTmp);
  };

  // 是否收藏 change事件
  const handleChange = async (payload: boolean) => {
    let valueTmp = payload;
    // 更新收藏状态 接口是否成功
    if (valueTmp) {
      handleGroupSettingPre();
    } else {
      try {
        await setFollowing({
          user_id: userId,
          entity_type: entityType ?? 'company',
          game_company_id: companyId ?? '',
          is_collection: valueTmp,
        });
        // 收藏成功后，更新缓存的收藏状态
        cachedValue.current = valueTmp;
        setFavarite(valueTmp);
      } catch (exception) {
        // 收藏首败，回退到最近一次更新后的正确的收藏状态
        setFavarite(cachedValue.current);
        valueTmp = cachedValue.current;
      }
    }
  };

  useEffect(() => {
    initialIsFollowing(companyId);
  }, [companyId]);

  const addrInfo: string = (() => {
    const countryName = basicInfo?.location_country;
    const cityName = basicInfo?.location_city;
    return [cityName, countryName].filter((item) => item).join(', ');
  })();

  const handleGroupSettingPre = async () => {
    try {
      const params = {
        entity_type: entityType,
      };
      const res = await fetchFollowingGroups(params);
      const groupList = res?.data?.group_lists;
      const groupOption = groupList?.map((item: any) => {
        return {
          value: item?.entity_name,
          text: `${item?.entity_name} (${item?.game_list_total})`,
        };
      });
      setGroupOptions(groupOption);
      setAddGroup(true);
    } catch (exception) {
      setGroupOptions([
        {
          value: DEFAULT_GROUPNAME,
          text: `${DEFAULT_GROUPNAME} (0)`,
        },
      ]);
      console.warn(exception);
    }
  };

  const handleAddGroupClose = () => {
    setAddNewGroupName('');
    setAddGroup(false);
  };

  const setAddGroupHandle = (val: any) => {
    handleGroupSettingPre();
    setAddGroup(val);
  };

  return (
    <>
      <div className="dbi-details-header-between dbi-companies-details-header-content">
        {/* 暂时先放头像， 后续需要开发传入需要的背景 */}
        <div className={'dbi-header-bg'}>
          {/* <div className={false ? 'dbi-header-bg-new' : 'dbi-header-bg'}> */}
          {/* <img  src={basicInfo?.img_url}/> */}
          <div
            className="dbi-header-bg-img"
            style={{ backgroundImage: `url(${basicInfo?.bg_url})` }}
          />
        </div>
        <div className="dbi-details-header-left">
          <GameImage
            className={'right-header-img active-img-one'}
            src={basicInfo?.img_url}
            entityType={entityType}
          />
          {/* <img className="active-img-four" src={basicInfo?.img_url} /> */}
          <div className="active-message">
            <div className="active-message-title">{basicInfo?.name}</div>
            <div className="active-message-change">
              <img
                src={getCountryFlag(basicInfo?.national_flag?.toLowerCase())}
                className="change-img"
              />
              <span className="change-text">{addrInfo}</span>
            </div>
            <div className="active-message-tab">
              <span className="tab-show">
                {basicInfo?.game_sum ?? 0} {formatMessage({ id: 'dbi_games' })}
              </span>
              {genres?.map((item: string) => (
                <span className="tab-item" key={item}>
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="dbi-details-header-right">
          {/* 子母公司切换 */}
          <ParentSubsidiaryCompanySelect
            className={COMPANY_GUIDE_CLASSNAMES.ELEMENT3}
            // 头部还在loading时禁止打开子母公司切换，loading时 CompanyHeader组件不会渲染，所以这里直接给false
            isDisabledOpen={false}
            getIsOnSubsidiary={getIsOnSubsidiary}
            value={companyId}
            onChange={onCompanyIdChange}
          />
          <FollowBtn value={favarite} onChange={handleChange} />
        </div>

        <RenameAddGroup
          visible={createNewGroup}
          mainSegment={entityType}
          setCreateRenameGroup={setCreateNewGroup}
          mode={MODE}
          openAddUpateGroup={handleGroupSettingPre}
          setAddNewGroupName={setAddNewGroupName}
        />
        <AddGroup
          visible={addGroup}
          close={handleAddGroupClose}
          entityType={entityType}
          gameId={companyId}
          setFavarite={setFavarite}
          setAddGroup={setAddGroupHandle}
          groupOptions={groupOptions}
          DEFAULT_GROUPNAME={DEFAULT_GROUPNAME}
          favarite={favarite}
          addNewGroupName={addNewGroupName}
          getCreateGroup={() => {
            setAddGroup(false);
            setCreateNewGroup(true);
          }}
        />
      </div>
      <CompanyUserGuide />
    </>
  );
};

export default CompanyHeader;
